var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 378,
    viewBox: "0 0 379 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.042 252H205.292C161.754 252 126.333 216.673 126.333 173.25V78.75C126.333 35.3273 161.754 0 205.292 0H300.042C343.579 0 379 35.3273 379 78.75V173.25C379 216.673 343.579 252 300.042 252ZM173.708 378H78.9583C35.4207 378 0 342.673 0 299.25V204.75C0 161.327 35.4207 126 78.9583 126C87.6911 126 94.75 133.056 94.75 141.75V173.25C94.75 234.045 144.352 283.5 205.292 283.5H236.875C245.608 283.5 252.667 290.556 252.667 299.25C252.667 342.673 217.246 378 173.708 378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 379,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloner);
export default __webpack_public_path__ + "static/media/cloner.341c74d3b3840e2447710da8dfc2a6cf.svg";
export { ForwardRef as ReactComponent };